<template>
  <div class="lower-page not-found">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('confirm_login_information') }}</h2>
    </div>
    <section class="wrapper">
      <p class="txt">{{ $t('successfully_changed') }}</p>
        <p class="topLink">
          <router-link :to="{ name: 'Client Property', params: { lang: $route.params.lang } }" tag="button" class="brown_btn" id="withdrawalBtn"><span>TOP</span></router-link>
        </p>
    </section>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      }
    }
  },
  components: {
    navbar,
    footerClient
  }
}
</script>
